import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SmartSearchPromptComponent } from '../../../components/smart-search-prompt/smart-search-prompt.component';
import { SmartSearchPromptModalComponent } from '../../../components/smart-search-prompt-modal/smart-search-prompt-modal.component';
import { CommonExplainModule } from '../../../common-explain/common-explain.module';
import { FormsModule } from '@angular/forms';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { SmartSearchTagComponent } from '../../../components/smart-search-tag/smart-search-tag.component';

@NgModule({
  declarations: [SmartSearchPromptComponent, SmartSearchPromptModalComponent],
  exports: [SmartSearchPromptComponent],
  imports: [CommonModule, CommonExplainModule, FormsModule, NgbTooltip, SmartSearchTagComponent],
})
export class SmartSearchPromptModule {}
